//@ts-nocheck
import React from 'react'
import T from 'prop-types'
import _ from 'lodash'
import withFeatures from 'hoc/withFeatures'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

import CheckboxFilterControl from './CheckboxFilterControl'
import InputFilterControl from './InputFilterControl'

import RangeFilterControl from './RangeFilterControl'

import css from './filtersControl.module.css'
import { Button } from '@wework/dieter-ui'

const minDate = new Date('2019-01-01')
const maxDate = new Date('2023-12-31')
const dateFormat = 'yyyy-MM-dd'
const dateStringFormat = 'MMM dd, yyyy'

class FiltersControl extends React.PureComponent {
  state = {}

  render() {
    const {
      onFilterChange,
      filters,
      hasAppliedFilters,
      toggleResultList,
      features,
      loading,
      isSearchDrawerOpen,
    } = this.props

    const price = _.get(filters, 'price')
    const capacity = _.get(filters, 'capacity')
    const dateAvailability = _.get(filters, 'availability')
      ? {
          from: parseISO(filters.availability.from),
          to: parseISO(filters.availability.to),
        }
      : undefined
    const dateMi = _.get(filters, 'mimo.mi')
      ? {
          from: parseISO(filters.mimo.mi.from),
          to: parseISO(filters.mimo.mi.to),
        }
      : undefined
    const dateMo = _.get(filters, 'mimo.mo')
      ? {
          from: parseISO(filters.mimo.mo.from),
          to: parseISO(filters.mimo.mo.to),
        }
      : undefined
    const hasWindow = _.get(filters, 'hasWindow')
    const hasInternalRoom = _.get(filters, 'hasInternalRoom')
    const onhold = _.get(filters, 'onhold')
    const pendingPPWK = _.get(filters, 'pendingPPWK')
    const expiredPPWK = _.get(filters, 'expiredPPWK')
    const spaceType = _.get(filters, 'spaceType')
    const commitmentDateStart = _.get(
      filters,
      'commitmentDates.commitmentStart'
    )
      ? {
          from: parseISO(filters.commitmentDates.commitmentStart.from),
          to: parseISO(filters.commitmentDates.commitmentStart.to),
        }
      : undefined
    const commitmentDateEnd = _.get(filters, 'commitmentDates.commitmentEnd')
      ? {
          from: parseISO(filters.commitmentDates.commitmentEnd.from),
          to: parseISO(filters.commitmentDates.commitmentEnd.to),
        }
      : undefined

    const attributesCheckboxes = [
      {
        name: 'Has Windows',
        key: 'hasWindow',
        checked: hasWindow === undefined ? false : hasWindow,
      },
      {
        name: 'Has Internal Room',
        key: 'hasInternalRoom',
        checked: hasInternalRoom === undefined ? false : hasInternalRoom,
      },
    ]

    const statusCheckboxes = [
      {
        name: 'On Hold',
        key: 'onhold',
        checked: onhold === undefined ? false : onhold,
      },
      {
        name: 'Pending PPWK',
        key: 'pendingPPWK',
        checked: pendingPPWK === undefined ? false : pendingPPWK,
      },
      {
        name: 'Expired PPWK',
        key: 'expiredPPWK',
        checked: expiredPPWK === undefined ? false : expiredPPWK,
      },
    ]

    const amenitiesCheckboxes = [
      {
        name: 'Meeting Room',
        key: 'meet',
        checked: false,
      },
      {
        name: 'Nook',
        key: 'nook',
        checked: false,
      },
      {
        name: 'Phone Booth',
        key: 'phone booth',
        checked: false,
      },
    ]

    const productTypeCheckboxes = [
      {
        name: 'Dedicated Desk',
        key: 'DedicatedDesk',
        checked: false,
      },
      {
        name: 'Office',
        key: 'Office',
        checked: false,
      },
      {
        name: 'WWLO',
        key: 'WWLO',
        checked: false,
      },
      {
        name: 'Shared Office Desk',
        key: 'SharedOfficeDesk',
        checked: false,
      },
      {
        name: 'Hot Desk',
        key: 'HotDesk',
        checked: false,
      },
      {
        name: 'Private Hot Desk Area',
        key: 'PrivateHotDeskArea',
        checked: false,
      },
    ]

    if (filters.type) {
      filters.type.forEach(t => {
        for (let i = 0; i < productTypeCheckboxes.length; i += 1) {
          if (productTypeCheckboxes[i].key === t) {
            productTypeCheckboxes[i].checked = true
          }
        }
      })
    }

    if (spaceType) {
      spaceType.forEach(t => {
        for (let i = 0; i < amenitiesCheckboxes.length; i += 1) {
          if (amenitiesCheckboxes[i].key === t) {
            amenitiesCheckboxes[i].checked = true
          }
        }
      })
    }

    const filtersFeature = _.get(features, 'filters', {})

    const AvailabilityFilter =
      filtersFeature.availability === true ? (
        <RangeFilterControl
          date={dateAvailability}
          label="Availability"
          minDate={minDate}
          maxDate={maxDate}
          disabled={loading}
          setChipLabel={value => {
            return `Available between ${format(
              value.from,
              dateStringFormat
            )} - ${format(value.to, dateStringFormat)}`
          }}
          onDelete={() => {
            onFilterChange({ availability: undefined })
          }}
          onChange={date => {
            onFilterChange({
              availability: {
                from: format(date.from, dateFormat),
                to: format(date.to, dateFormat),
              },
            })
          }}
        />
      ) : null

    const SizeFilter =
      filtersFeature.capacity === true ? (
        <InputFilterControl
          label="Size"
          submittedValue={capacity}
          // eslint-disable-next-line max-len
          descriptions="Use comma to separate multiple size (e.g. 2,4,10) or enter a range of numbers (e.g. 2-10)"
          placeholder="Enter size / capacity"
          setChipLabel={value => {
            return `${value} desk`
          }}
          onSubmit={value => {
            onFilterChange({ capacity: value })
          }}
          onDelete={() => {
            onFilterChange({ capacity: undefined })
          }}
          disabled={loading}
        />
      ) : null

    const PriceFilter =
      filtersFeature.price === true ? (
        <InputFilterControl
          label="Price"
          submittedValue={price}
          // eslint-disable-next-line max-len
          descriptions="Use comma to separate multiple prices (e.g. 200,400,1000) or enter a range of numbers (e.g. 2000-5000)"
          placeholder="Enter price"
          setChipLabel={value => {
            return `SGD ${value}`
          }}
          onSubmit={value => {
            onFilterChange({ price: value })
          }}
          onDelete={() => {
            onFilterChange({ price: undefined })
          }}
          disabled={loading}
        />
      ) : null

    const ProductTypeFilter =
      filtersFeature.type === true ? (
        <CheckboxFilterControl
          label="Inventory Type"
          checkBoxes={productTypeCheckboxes}
          onChecked={(checkBoxes, checked) => {
            onFilterChange({ type: checked.length > 0 ? checked : undefined })
          }}
          disabled={loading}
        />
      ) : null

    const AttributeFilter =
      filtersFeature.attribute === true ? (
        <CheckboxFilterControl
          label="Attributes"
          checkBoxes={attributesCheckboxes}
          onChecked={checkBoxes => {
            const filterChange = {}
            if (checkBoxes) {
              checkBoxes.forEach(c => {
                filterChange[c.key] = c.checked ? true : undefined
              })
            }

            onFilterChange({
              ...filterChange,
            })
          }}
          disabled={loading}
        />
      ) : null

    const StatusFilter =
      filtersFeature.status === true ? (
        <CheckboxFilterControl
          label="Status"
          checkBoxes={statusCheckboxes}
          onChecked={checkBoxes => {
            const filterChange = {}
            if (checkBoxes) {
              checkBoxes.forEach(c => {
                filterChange[c.key] = c.checked ? true : undefined
              })
            }

            onFilterChange({
              ...filterChange,
            })
          }}
          disabled={loading}
        />
      ) : null

    const MimoFilter =
      filtersFeature.mimo === true ? (
        <>
          <RangeFilterControl
            label="MI"
            date={dateMi}
            onChange={date => {
              onFilterChange({
                mimo: {
                  mi: {
                    from: format(date.from, dateFormat),
                    to: format(date.to, dateFormat),
                  },
                  mo: dateMo
                    ? {
                        from: format(dateMo.from, dateFormat),
                        to: format(dateMo.to, dateFormat),
                      }
                    : undefined,
                },
              })
            }}
            onDelete={() => {
              if (dateMo) {
                onFilterChange({
                  mimo: {
                    mi: undefined,
                    mo: {
                      from: format(dateMo.from, dateFormat),
                      to: format(dateMo.to, dateFormat),
                    },
                  },
                })
              } else {
                onFilterChange({
                  mimo: undefined,
                })
              }
            }}
            minDate={minDate}
            maxDate={maxDate}
            setChipLabel={value => {
              return `Move-in between ${format(
                value.from,
                dateStringFormat
              )} -  ${format(value.to, dateStringFormat)}`
            }}
            disabled={loading}
          />
          <RangeFilterControl
            label="MO"
            date={dateMo}
            onChange={date => {
              onFilterChange({
                mimo: {
                  mi: dateMi
                    ? {
                        from: format(dateMi.from, dateFormat),
                        to: format(dateMi.to, dateFormat),
                      }
                    : undefined,
                  mo: {
                    from: format(date.from, dateFormat),
                    to: format(date.to, dateFormat),
                  },
                },
              })
            }}
            onDelete={() => {
              if (dateMi) {
                onFilterChange({
                  mimo: {
                    mi: {
                      from: format(dateMi.from, dateFormat),
                      to: format(dateMi.to, dateFormat),
                    },
                    mo: undefined,
                  },
                })
              } else {
                onFilterChange({
                  mimo: undefined,
                })
              }
            }}
            minDate={minDate}
            maxDate={maxDate}
            setChipLabel={value => {
              return `Move-out between ${format(
                value.from,
                dateStringFormat
              )} - ${format(value.to, dateStringFormat)}`
            }}
            disabled={loading}
          />
        </>
      ) : null

    const SpaceTypeFilter =
      filtersFeature.spaceType === true ? (
        <CheckboxFilterControl
          label="Amenities"
          checkBoxes={amenitiesCheckboxes}
          onChecked={(checkBoxes, checked) => {
            onFilterChange({
              spaceType: checked.length > 0 ? checked : undefined,
            })
          }}
          disabled={loading}
        />
      ) : null

    const StartCommitmentDatesFilter =
      filtersFeature.commitmentDates === true ? (
        <RangeFilterControl
          date={commitmentDateStart}
          disabled={loading}
          label="Commitment Dates Start"
          minDate={minDate}
          maxDate={maxDate}
          setChipLabel={value => {
            return `Commitment starts between ${format(
              value.from,
              dateStringFormat
            )} - ${format(value.to, dateStringFormat)}`
          }}
          onDelete={() => {
            if (commitmentDateEnd) {
              onFilterChange({
                commitmentDates: {
                  commitmentStart: undefined,
                  commitmentEnd: commitmentDateEnd
                    ? {
                        from: format(commitmentDateEnd.from, dateFormat),
                        to: format(commitmentDateEnd.to, dateFormat),
                      }
                    : undefined,
                },
              })
            } else {
              onFilterChange({ commitmentDates: undefined })
            }
          }}
          onChange={date => {
            onFilterChange({
              commitmentDates: {
                commitmentStart: {
                  from: format(date.from, dateFormat),
                  to: format(date.to, dateFormat),
                },
                commitmentEnd: commitmentDateEnd
                  ? {
                      from: format(commitmentDateEnd.from, dateFormat),
                      to: format(commitmentDateEnd.to, dateFormat),
                    }
                  : undefined,
              },
            })
          }}
        />
      ) : null

    const EndCommitmentDatesFilter =
      filtersFeature.commitmentDates === true ? (
        <RangeFilterControl
          date={commitmentDateEnd}
          label="Commitment Dates End"
          minDate={minDate}
          disabled={loading}
          maxDate={maxDate}
          containerStyle={{ position: 'absolute', left: '-150px' }}
          setChipLabel={value => {
            return `Commitment ends between ${format(
              value.from,
              dateStringFormat
            )} - ${format(value.to, dateStringFormat)}`
          }}
          onDelete={() => {
            if (commitmentDateStart) {
              onFilterChange({
                commitmentDates: {
                  commitmentStart: commitmentDateStart
                    ? {
                        from: format(commitmentDateStart.from, dateFormat),
                        to: format(commitmentDateStart.to, dateFormat),
                      }
                    : undefined,
                  commitmentEnd: undefined,
                },
              })
            } else {
              onFilterChange({ commitmentDates: undefined })
            }
          }}
          onChange={date => {
            onFilterChange({
              commitmentDates: {
                commitmentStart: commitmentDateStart
                  ? {
                      from: format(commitmentDateStart.from, dateFormat),
                      to: format(commitmentDateStart.to, dateFormat),
                    }
                  : undefined,
                commitmentEnd: {
                  from: format(date.from, dateFormat),
                  to: format(date.to, dateFormat),
                },
              },
            })
          }}
        />
      ) : null

    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div
            className={css.filtersControl}
            style={{ overflow: 'auto', whiteSpace: 'nowrap' }}
          >
            {AvailabilityFilter}
            {SizeFilter}
            {PriceFilter}
            {ProductTypeFilter}
            {AttributeFilter}
            {StatusFilter}
            {MimoFilter}
            {SpaceTypeFilter}
            {StartCommitmentDatesFilter}
            {EndCommitmentDatesFilter}
          </div>
        </div>
        <div>
          <div
            style={{
              width: '100%',
              height: '64px',
              boxShadow: '-10px -5px 16px 1px rgba(0,0,0,.08)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                paddingRight: 0,
                display: 'flex',
                position: 'relative',
                alignItems: 'center',
                paddingLeft: 24,
                minHeight: 64,
              }}
            >
              {hasAppliedFilters && !loading ? (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      onFilterChange({
                        search: undefined,
                        availability: undefined,
                        capacity: undefined,
                        price: undefined,
                        type: undefined,
                        spaceType: undefined,
                        hasWindow: undefined,
                        hasInternalRoom: undefined,
                        mimo: undefined,
                        pendingPPWK: undefined,
                        expiredPPWK: undefined,
                        onhold: undefined,
                        commitmentDates: undefined,
                      })
                    }}
                  >
                    Clear
                  </Button>
                </>
              ) : (
                <Button variant="contained" primary size="small" disabled>
                  Clear
                </Button>
              )}
              {hasAppliedFilters ? (
                <div style={{ padding: '10px' }}>
                  <Button
                    basic
                    size="small"
                    onClick={() => {
                      toggleResultList()
                    }}
                    disabled={!hasAppliedFilters || loading}
                  >
                    {isSearchDrawerOpen && hasAppliedFilters && !loading
                      ? 'Hide Results'
                      : 'Show Results'}
                  </Button>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

FiltersControl.propTypes = {
  filters: T.object.isRequired,
  onFilterChange: T.func,
  hasAppliedFilters: T.bool,
  isSearchDrawerOpen: T.bool,
  toggleResultList: T.func,
  features: T.object,
}

FiltersControl.defaultProps = {
  onFilterChange: () => {},
  hasAppliedFilters: false,
  isSearchDrawerOpen: false,
  toggleResultList: () => {},
  features: {},
}

export default withFeatures()(FiltersControl)
